<template>
  <div>
    <card class="mb-2">
    <div slot="header" block>
      <flexbox class="p-2" orient="vertical">
        <flexbox>
          <flexbox-item :span="8">
            {{$t('cart.order.orderNumber')}} {{order.orderNumber}}
          </flexbox-item>
          <flexbox-item class="text-right">
            <span :class="paymentStatusColorMapping(order.paymentStatus)">{{paymentStatusMapping(order.paymentStatus)}}</span>
          </flexbox-item>
        </flexbox>
        <flexbox-item>
          <p style="color: gray">{{$t('cart.order.orderTime')}} {{order.orderTime}}</p>
        </flexbox-item>
      </flexbox>
      <div v-if="order.paymentStatus == 'S'">
        <flow>
          <flow-state class="logisticStatus" state="1" :title="$t('cart.logistic.ordered')" :is-done="ordered"></flow-state>
          <flow-line class="logisticStatus" :is-done="packaged"></flow-line>
          <flow-state class="logisticStatus" state="2" :title="$t('cart.logistic.packaged')" :is-done="packaged"></flow-state>
          <flow-line class="logisticStatus" :is-done="delivered"></flow-line>
          <flow-state class="logisticStatus" state="3" :title="$t('cart.logistic.delivered')" :is-done="delivered"></flow-state>
          <flow-line class="logisticStatus" :tip="tip" :is-done="received" ></flow-line>
          <flow-state class="logisticStatus" state="4" :title="$t('cart.logistic.received')" :is-done="received"></flow-state>
        </flow>
      </div>
    </div>
    <div slot="content" class="card-padding">      
      <OrderItemList :list="order.products" :currency="order.currency" :actualAmount="order.actualAmount" :tariff="order.tariff" :discount="order.discount" :shippingFee="order.shippingFee" :orderStatus="order.paymentStatus"></OrderItemList>
    </div>
    <div slot="footer" class="text-right p-2" >
      <span v-if="order.rejectReason != null && order.rejectReason != '' " class="red">{{$t('cart.payment.reject')}}:{{order.rejectReason}}</span>
      <b-button variant="success" v-if="order.paymentStatus == 'S' && order.orderStatus == 'D' " :pressed.sync="confirmReceived" >{{$t('cart.logistic.confirm')}}</b-button>
      <b-button variant="success" v-if="order.paymentStatus == 'P' && order.receiptStatus == null " :pressed.sync="confirm" >{{$t('cart.logistic.cancel')}}</b-button>
      <b-button variant="success" v-if="order.paymentStatus == 'P' && order.receiptStatus == null " @click="prePay(order)">{{$t('cart.payment.pay')}}</b-button>
      <b-button variant="outline-secondary" v-if="order.receiptStatus == 'P' " disabled>{{$t('cart.payment.pending')}}</b-button>
      <b-button variant="outline-primary" v-if="order.receiptStatus == 'F' " @click="repay(order)">{{$t('cart.payment.repay')}}</b-button>
    </div>
    </card>
    <actionsheet
      v-model="showPaymentMethods"
      :menus="paymentMethodList"
      @on-click-menu="pay"
      @on-after-hide=""
      @on-after-show="">
    </actionsheet>
    <div v-transfer-dom>
      <confirm v-model="confirm" :title="$t('general.confirm')" :confirm-text="$t('general.confirm')" :cancel-text="$t('general.cancel')" @on-confirm="cancelOrder(order)" >
        <p>{{$t('cart.logistic.cancelConfirm')}}</p>
      </confirm>
      <confirm v-model="confirmReceived" :title="$t('general.confirm')" :confirm-text="$t('general.confirm')" :cancel-text="$t('general.cancel')" @on-confirm="setOrderStatus(order)" >
        <p>{{$t('cart.logistic.receiveConfirm')}}</p>
      </confirm>
    </div>
    
  </div>
</template>
<script type="text/javascript">

import { Card, Flexbox, FlexboxItem, Actionsheet, Confirm, TransferDomDirective as TransferDom, Flow, FlowState, FlowLine, Alert} from 'vux'
import OrderItemList from './OrderItemList'
import moment from 'moment'

export default {
  name: 'Order',
  directives: {
    TransferDom
  },
  components: {
    OrderItemList,
    Card,
    Flexbox, 
    FlexboxItem,
    Actionsheet,
    Confirm,
    Flow,
    FlowState,
    FlowLine,
    Alert
  },
  props: {
    order: Object
  },
  data() {
    return {
      showPaymentMethods: false,
      confirm: null,
      paymentMethodList: {
        // W: this.$t('cart.payment.wechat'),
        S: this.$t('cart.payment.stripe'),
        T: this.$t('cart.payment.transfer'),
        // D: "積分付款"
        // C: this.$t('cart.payment.cash')
      },
      currentOrder: {},
      ordered: false,
      packaged: false,
      delivered: false,
      received: false,
      tip: "",
      confirmReceived: null,
      deliveryAlert: false
    }
  },
  created() {
    this.$store.commit("hideFooter", true);
  },
  mounted() {
    this.orderStatusMapping(this.order);
  },
  watch: {
    order(){
      this.orderStatusMapping(this.order);
      this.checkOrderStatus(this.order);
    }
  },
  computed: {
    list(){

    }
  },
  methods: {
    paymentStatusMapping(paymentStatus){
      switch(paymentStatus){
        case 'P':
          return this.$t('cart.order.paymentStatus.P');
        case 'S':
          return this.$t('cart.order.paymentStatus.S');
        case 'F':
          return this.$t('cart.order.paymentStatus.F');
        case 'C':
          return '已取消';
        default:
          return ''
      }
    },
    paymentStatusColorMapping(paymentStatus){
      switch(paymentStatus){
        case 'P':
          return 'text-warning';
        case 'S':
          return 'text-success';
        case 'F':
          return 'text-danger';
        case 'C':
          return 'text-danger';
        default:
          return ''
      }
    },
    prePay(order){
      this.currentOrder = order;
      this.showPaymentMethods = true;
    },
    repay(order){
      this.currentOrder = order;
      this.pay('T');
    },
    cancelOrder(order){
      this.currentOrder = order;
      this.$store.dispatch('Cart/cancelOrder', {
        orderID: parseInt(this.currentOrder.ID)
      })
      .then((json) => {
      
        if(json.status == 401){
          Cookies.remove('token');
          this.$router.push('/login?type=1');
        }else if(json.status == 200){
          this.$emit('updateOrderList')
        }
      }).catch((err) => {
        console.error(err);
      });
    },

    pay(paymentMethod){

      switch(paymentMethod){
        case 'S':
          this.$router.push({
              name:'Payment',
              params:{
                currency: this.currentOrder.currency,
                orderNumber: this.currentOrder.orderNumber,
                orderID: this.currentOrder.ID+"",
                actualAmount: this.currentOrder.actualAmount,
                type:paymentMethod
              }
          });
          break;
        case 'T':
          this.$router.push({
              name:'Payment',
              params:{
                currency: this.currentOrder.currency,
                orderNumber: this.currentOrder.orderNumber,
                orderID: this.currentOrder.ID+"",
                actualAmount: this.currentOrder.actualAmount,
                type:paymentMethod
              }
          });
        // case 'D':
        //   this.$router.push({
        //       name:'Payment',
        //       params:{
        //         currency: this.currentOrder.currency,
        //         orderNumber: this.currentOrder.orderNumber,
        //         orderID: this.currentOrder.ID+"",
        //         actualAmount: this.currentOrder.actualAmount,
        //         type:paymentMethod
        //       }
        //   });
        //   break;
          break;
        default:
          break;
      }
    },
    orderStatusMapping(order){
      if(order.paymentStatus == "S"){
        switch(order.orderStatus){
          case 'O':
            this.ordered = true; 
            break;
          case 'P':
            this.ordered = true;
            this.packaged = true;
            break;
          case 'D':
            this.ordered = true;
            this.packaged = true;
            this.delivered = true;
            this.tip = "運送中"
            break;
          case 'R':
            this.ordered = true;
            this.packaged = true;
            this.delivered = true;
            this.received = true;
            break;
          default:
            break;
        }
      }else{
        this.ordered = false,
        this.packaged = false,
        this.delivered = false,
        this.received = false,
        this.tip =  ""
      }
    },
    setOrderStatus(order){
      this.$store.dispatch('Cart/setOrderStatus', {
        orderStatus: 'R',
        orderID: parseInt(order.ID),
        receiveTime: moment().format("YYYY-MM-DD, h:mm:ss")
      })
      .then((json) => {
      
        if(json.status == 401){
          Cookies.remove('token');
          this.$router.push('/login?type=1');
        }else if(json.status == 200){
          this.$emit('updateOrderList')
          this.orderStatusMapping(this.currentOrder)
        }
      }).catch((err) => {
        console.error(err);
      });
    },
    checkOrderStatus(order){
      let now = moment();
      let deliveryTime = moment(order.deliveryTime);
      if(now.diff(deliveryTime,'days') > 7 && order.orderStatus == 'D' && this.deliveryAlert == false){
        this.$emit('deliveryAlert')
      }
    },
  }
}

</script>
<style type="text/css">
.checkout-footer{
  overflow:hidden; position: 
  fixed;bottom: 0px;
  width: 100%;
}
.red{
  text-align: left;
  color:red;
  margin-right: 2rem;
}
.logisticStatus {
  z-index: auto !important;
}
</style>




// WEBPACK FOOTER //
// src/Cart/components/Order.vue